<ng-container *transloco="let t">
  <section
    id="benefitsBanner"
    class="benefits-banner"
    [class.widescreen]="(biggerThan$ | async)?.sm">
    <section class="content popsy-card secondary">
      <!-- Slider Display-->
      <span class="col">
        <swiper
          class="feed-swiper swiper"
          [class.widescreen]="(biggerThan$ | async)?.sm"
          [class.desktop]="(biggerThan$ | async)?.mobileL"
          [loop]="true"
          [autoplay]="{ delay: 6000, pauseOnMouseEnter: true }"
          [zoom]="false"
          [hashNavigation]="{ watchState: true }"
          [breakpoints]="{
            '100': {
              slidesPerView: 1,
              spaceBetween: 16
            },
            '720': {
              slidesPerView: 1,
              spaceBetween: 16
            }
          }"
          [spaceBetween]="32"
          [slidesPerView]="1"
          [pagination]="{ clickable: true, type: 'bullets', el: '.swiper-pag' }"
          [navigation]="{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }"
          [thumbs]="{ swiper: thumbsSwiper }">
          <ng-template swiperSlide>
            <div class="slide">
              <div class="content flex gap-32">
                <div class="title flex flex-col gap-16">
                  @if (language === 'en') {
                    <h1>Why Choose Refurbished?</h1>
                  } @else {
                    <h1>لماذا تختار تجديد؟</h1>
                  }
                </div>
                <div class="row flex flex-col gap-16">
                  <div class="table popsy-card">
                    <span class="fixed-space-24" aria-hidden="true"></span>

                    <span>
                      <popsy-icon-logo-popsy class="popsy-icon" />
                    </span>
                    @if (language === 'en') {
                      <span class="second">New</span>
                    } @else {
                      <span class="second"> جديد </span>
                    }

                    @if (language === 'en') {
                      <span class="second">Used</span>
                    } @else {
                      <span class="second">التكنولوجيا المستخدمة</span>
                    }

                    @if (language === 'en') {
                      <span>Up to 70% cheaper </span>
                    } @else {
                      <span>- أرخص بنسبة تصل إلى %70 </span>
                    }
                    <popsy-icon-check-blue class="icon" />
                    <popsy-icon-remove class="icon gray-01" />
                    <popsy-icon-check-blue class="icon" />

                    <span class="line fill-row"></span>

                    <span class="fixed-space-8 fill-row" aria-hidden="true"></span>

                    @if (language === 'en') {
                      <span>High Quality</span>
                    } @else {
                      <span>- جودة عالية </span>
                    }
                    <popsy-icon-check-blue class="icon" />
                    <popsy-icon-check-blue class="icon" />

                    <popsy-icon-remove class="icon gray-01" />

                    <span class="line fill-row"></span>

                    @if (language === 'en') {
                      <span>Up to 36 months warranty </span>
                    } @else {
                      <span>- ضمان يصل الى 36 شهر </span>
                    }
                    <popsy-icon-check-blue class="icon" />
                    <popsy-icon-remove class="icon gray-01" />
                    <popsy-icon-remove class="icon gray-01" />

                    @if ((biggerThan$ | async)?.sm) {
                      <span class="line fill-row"></span>

                      @if (language === 'en') {
                        <span>Customer support </span>
                      } @else {
                        <span>- خدمة العملاء </span>
                      }
                      <popsy-icon-check-blue class="icon" />
                      <popsy-icon-check-blue class="icon" />

                      <popsy-icon-remove class="icon gray-01" />
                    }

                    <span class="line fill-row"></span>

                    @if (language === 'en') {
                      <span>Sustainable </span>
                    } @else {
                      <span>- مستمر </span>
                    }
                    <popsy-icon-check-blue class="icon" />
                    <popsy-icon-remove class="icon gray-01" />
                    <popsy-icon-check-blue class="icon" />

                    @if ((biggerThan$ | async)?.sm) {
                      <span class="line fill-row"></span>

                      @if (language === 'en') {
                        <span>Pay in installments </span>
                      } @else {
                        <span>- الدفع بالتقسيط </span>
                      }
                      <popsy-icon-check-blue class="icon" />
                      <popsy-icon-check-blue class="icon" />
                      <popsy-icon-remove class="icon gray-01" />
                    }

                    <span class="fixed-space-16 fill-row" aria-hidden="true"></span>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>

          <ng-template swiperSlide>
            <div class="slide">
              <div class="content flex gap-32">
                <div class="title flex flex-col gap-16">
                  @if (language === 'en') {
                    <h1>Refurbished with Care</h1>
                  } @else {
                    <h1>تجديد بعناية</h1>
                  }
                </div>
                <div class="row flex flex-col gap-16">
                  <div class="flex flex-col popsy-card gap-16 p-32-64">
                    <span class="flex-mobile gap-16">
                      <span>
                        <popsy-icon-tool-dark class="icon badge" />
                      </span>
                      @if (language === 'en') {
                        <span>Rigorous Testing</span>
                      } @else {
                        <span>اختبارات صارمة</span>
                      }
                    </span>

                    <span class="flex-mobile gap-16">
                      <span>
                        <popsy-icon-certified-dark class="icon badge" />
                      </span>
                      @if (language === 'en') {
                        <strong>Expertly Refurbished </strong>
                      } @else {
                        <strong>تجديد بإتقان </strong>
                      }
                    </span>

                    <span class="flex-mobile gap-16">
                      <span>
                        <popsy-icon-warranty-dark class="icon badge" />
                      </span>
                      @if (language === 'en') {
                        <strong>Free Warranty</strong>
                      } @else {
                        <strong>ضمان مجاني</strong>
                      }
                    </span>

                    <span class="flex-mobile gap-16">
                      <span>
                        <popsy-icon-return-dark class="icon badge" />
                      </span>
                      @if (language === 'en') {
                        <strong>Hassle-Free Returns </strong>
                      } @else {
                        <strong>إرجاع دون تعقيدات </strong>
                      }
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>

          <!--   <ng-template swiperSlide>
            <div class="slide">
              <div class="content flex gap-32">
                <div class="title flex flex-col gap-16">
                  @if (language === 'en') {
                    <h1>Maximize Savings and Convenience</h1>
                  } @else {
                    <h1>وفر أكثر وتمتع بالراحة</h1>
                  }
                </div>
                <div class="row flex flex-col gap-16">
                  <div class="flex flex-col popsy-card gap-16 p-32-64">
                    <span class="flex-mobile item gap-16">
                      @if (language === 'en') {
                        <strong>Pay Less, Save More</strong>
                      } @else {
                        <strong>ادفع اقل ووفر أكثر</strong>
                      }
                    </span>

                    <span class="flex-mobile item gap-16">
                      @if (language === 'en') {
                        <strong>Installment Plans</strong>
                      } @else {
                        <strong>خطط أقساط ميسرة </strong>
                      }
                    </span>

                    <span class="flex-mobile item gap-16">
                      @if (language === 'en') {
                        <strong>Up to 36-Month Warranty</strong>
                      } @else {
                        <strong>ضمان يصل إلى 36 شهر</strong>
                      }
                    </span>

                    <span class="flex-mobile item gap-16">
                      @if (language === 'en') {
                        <strong>Free Shipping</strong>
                      } @else {
                        <strong>شحن مجاني </strong>
                      }
                    </span>

                    <span class="flex-mobile item gap-16">
                      @if (language === 'en') {
                        <strong>Safe & Secure Checkout</strong>
                      } @else {
                        <strong>عملية دفع آمنة </strong>
                      }
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </ng-template> -->
        </swiper>
      </span>
      <div class="navigation">
        <div class="swiper-pag"></div>
        <div class="swiper-button-prev swiper-butt"></div>
        <div class="swiper-button-next swiper-butt"></div>
      </div>
    </section>
  </section>
</ng-container>
